<template>
	<div class="form-group">
		<label :for="getFieldId" v-if="!withPlaceholder" v-text="placeholder"></label>
		<div class="input-group">
			<div class="custom-file">
				<input :id="getFieldId" type="file" ref="file" class="custom-file-input" @change="handleFileUpload()">
				<label class="custom-file-label" :for="getFieldId">Choose file</label>
			</div>
		</div>
	</div>
</template>
<script>

    let Input = require('@/mixins/InputField')
	import bsCustomFileInput from 'bs-custom-file-input'

	export default {

        mixins: [Input],

        mounted() {
            bsCustomFileInput.init()
        },

        data() {
            return {
                file: this.value
            }
        },

        methods: {
            handleFileUpload() {
                this.file = this.$refs.file.files[0]
                this.$emit('input', this.file);
            }
        }
    }
</script>
